<template>
  <div>
    <div v-if="this.loadingFormSubmit == true" class="loader">Loading...</div>

    <div v-if="this.loadingFormSubmit == false" class="form-container">
      <el-dialog
        :width="dialogWidth"
        title="Edit Work Order"
        :visible.sync="dialogFormVisible"
         @close="closeEditIssueForm()"      >
        <el-form :model="form" :rules="rules" ref="form" label-position="top">
          <el-form-item label="Work Order Title" prop="issuetitle">
              <el-input  
                class="tst-issue-title" 
                v-model="form.issuetitle" 
                placeholder="ex: machine makes a loud noise" 
                required>
            </el-input>
          </el-form-item>

          <el-form-item label="Work Order Description">
            <el-input 
               type="textarea"
              :autosize="{ minRows: 3, maxRows: 4}"
              class="tst-issue-desc" 
              v-model="form.description" 
              placeholder="ex: machine makes a loud noise when turning on, please check on it." 
              required>
            </el-input>
          </el-form-item>

          <el-form-item
           v-if="this.form.recurring == false" label="due date">

             <el-date-picker class="tst-issue-duedate" v-model="form.duedate" type="date" placeholder="Pick a day"></el-date-picker>
      
          <p class="error"
              v-if="this.duedateError == true"
            > Can't be earlier than today </p>

          </el-form-item>

          <!-- <el-form-item >
               <input type="checkbox" id="trackable-checkbox" v-model="form.istimetrackable">
               <label for="trackable-checkbox"> Can track hours?</label>      
          </el-form-item> -->

          <el-form-item 
          label="assign a tech to the Work Order">

            <AssignToIssue
              v-on:contact-assigned="assignContact($event)"
              :selectedUserId="this.issue.userassigned"
              :propertyid="this.issue.propertyid"
              :machineid="this.issue.machineid"
            />
          </el-form-item>

          <el-form-item label="Select priority level">
            <el-dropdown @command="selectPriority" trigger="click">
                  <el-button type="primary">
                    {{selectedPriority.issuepriorityname}}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>

              <el-dropdown-menu  slot="dropdown">
                <el-dropdown-item
                    v-for="priority in this.priorityList"
                    :key="priority.issuepriorityid"
                    :command="priority"
                >
                  {{priority.issuepriorityname}}
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-form-item>

       <el-form-item>
          <el-button 
          @click="makeIssueRecurring()"
          v-if="form.recurring == false" 
          > 
            Make recurring
          </el-button>
       </el-form-item>
          <div v-if="form.recurring == true">
            
           <el-form-item 
          v-if="this.form.scheduletype == 'interval'" 
         label="Recurring days"
          >

          <el-input          
          v-model="recurringDaysIntervalNumber" 
          placeholder="Enter number of days"
          oninput="this.value = this.value.replace(/[^0-9]/g, '')"
          > </el-input>

         </el-form-item>
          <el-form-item       
          v-if="$options.isAlreadyRecurring == false" 
           label="Start date"
           >

             <el-date-picker v-model="form.startdate" type="date" placeholder="Pick a day"></el-date-picker>
           <p class="error"
               v-if="this.startdateError == true"
            > Can't be earlier than today </p>
          </el-form-item>

          <el-form-item label="How long before can be completed">
              <el-input 
           v-model="form.cancompletedaysbefore" 
           placeholder="Enter number of days"
           oninput="this.value = this.value.replace(/[^0-9]/g, '')"
            > </el-input>
          </el-form-item>
 
          <p class="error"
         v-if="this.canCompleteError"
         > must be lower than recurring days </p>

          </div>

          <el-button class="tst-confirm-edit-issue" @click="updateIssue()">Update Work Order</el-button>
          <el-button class="tst-cancel-button" @click="closeEditIssueForm()">Cancel</el-button>
        </el-form>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import { mapState } from "vuex";
import AssignToIssue from "@/components/issues/AssignToIssue.vue";
import moment from 'moment'

export default {
  props: {
    issue: Object,
    priorityList: Array,
    propertytimeoffset: String
  },
  components: {
    AssignToIssue
  },
  data() {
    return {
      dialogFormVisible: true,
      dialog: false,
      dialogWidth: "50%",
      recurringDaysIntervalNumber: this.issue.recurringdays[0],
      selectedPriority: {},
      form: {
        candelete: this.issue.permissions.candelete,
        permissions: this.issue.permissions,
        issuetitle: this.issue.issuetitle,
        description: this.issue.description,
        userassigned: this.issue.userassigned,
        userassignedpicurl: this.issue.userassignedpicurl,
        userassignedname: this.issue.userassignedname,
        issueid: this.issue.issueid,
        machineid: this.issue.machineid,
        propertyid: this.issue.propertyid,
        propertytimeoffset: this.issue.propertytimeoffset != null ? this.issue.propertytimeoffset : this.propertytimeoffset,
        userid: "",
        note: "",
        openeddate: this.issue.openeddate,
        duedate: this.issue.duedate,
        status: this.issue.status,
        istimetrackable: this.issue.istimetrackable,
        recurring: this.issue.recurring,
        scheduletype: 'interval',
        startdate: null,
        recurringdays: this.issue.recurringdays.slice(0),
        cancompletedaysbefore: this.issue.cancompletedaysbefore,
        issuepriorityid: this.issue.issuepriorityid,
        issuepriorityname: this.issue.issuepriorityname
      },
      canCompleteError: false,
      duedateError: false,
      startdateError: false,
       rules: {
          issuetitle: [
            { required: true, message: 'Please input Issue Title', trigger: 'blur' },
          ],
       },
       invalid: Boolean,
       loadingFormSubmit: false
    };
  },
  mounted() {

        var savedPriority = this.priorityList.filter( i => i.issuepriorityid == this.issue.issuepriorityid)[0];
        this.selectPriority(savedPriority);
 
      this.$options.isAlreadyRecurring = this.issue.recurring;

      var x = window.matchMedia("(max-width: 979px)");
      if (x.matches) {
        this.dialogWidth = "100%";
      }
  },
  created() {
    this.form.userid = this.user.userid;
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    })
  },
  methods: {
    assignContact($event) {
      if($event == "Unassigned"){
         this.form.userassigned = null;
      }
      this.form.userassigned = $event;
    },
    closeEditIssueForm() {
      this.$emit("close-edit-issue-form");
       this.dialogFormVisible = false;

    }, 
    makeIssueRecurring(){
       this.form.recurring = true;
       this.recurringDaysIntervalNumber = 14;
       this.form.duedate = null;
    },
    getPropertyNowDate(){
       var now = new Date();

   // this is really a date of the users timezone since the offset at the end of the date doesn't say
   // 00:00 as utc but it says the current offset, but the idea is to just to add the hours to the local 
   // date it should match the hours of the current utc time. it's kind of a hack due to weak support for
   // (utc) dates in JavaScript

       var fakeUtcDate = new Date(now.getTime() + now.getTimezoneOffset() * 60000);

       fakeUtcDate.setHours(fakeUtcDate.getHours() + Number(this.timezoneDifference().timezoneHourDifference));

       var propertyZoneNowDate = fakeUtcDate.setMinutes(fakeUtcDate.getMinutes() + Number(this.timezoneDifference().timezoneMinuteDifference));
         
       return propertyZoneNowDate;
    },
     timezoneDifference(){
        var timezoneHourDifference = 0;

        var timezoneMinuteDifference = 0;

        

          if(this.form.propertytimeoffset.charAt(1) > 0 || this.form.propertytimeoffset.charAt(2) > 0){

                      if(this.form.propertytimeoffset.startsWith("-")){
                       timezoneHourDifference = this.form.propertytimeoffset.substring(0, 3);
                       timezoneMinuteDifference =  "-" + this.form.propertytimeoffset.substring(4, 6);

                      } else {
                      timezoneHourDifference = this.form.propertytimeoffset.substring(0, 2);
                      timezoneMinuteDifference = this.form.propertytimeoffset.substring(3, 5)

                      }
              } else{
                            if(this.form.propertytimeoffset.startsWith("-")){
                             timezoneMinuteDifference =  "-" + this.form.propertytimeoffset.substring(4, 6);
                            } else {
                              timezoneMinuteDifference = this.form.propertytimeoffset.substring(3, 5);
                            }
              } 

              return {
                timezoneHourDifference: timezoneHourDifference,
                timezoneMinuteDifference: timezoneMinuteDifference
              }
    },
    selectPriority(priority){
       this.selectedPriority = priority;
       this.form.issuepriorityid = priority.issuepriorityid;
       this.form.issuepriorityname = priority.issuepriorityname;
    },
    updateIssue() {

       this.$refs["form"].validate((valid) => {
          if (valid) {
            
          } else {
            this.invalid = true;
            return false;
          }
        });

        if(this.invalid == true){
          this.invalid = false;
          return;
        }

       if(this.form.duedate != null && this.form.duedate < new Date().setHours(0,0,0,0)){
          this.duedateError = true;
           return;
       }


       if(this.form.recurring == true){
         // if the issue was already recurring before the edit then leave the can complete a number, so if its empty it'll be a 0,
         // and if it wasn't recurring before and it's empty then send in null. the reason is for the API to handle it differently.
            if( this.$options.isAlreadyRecurring == true)
            {
              this.form.cancompletedaysbefore = Number(this.form.cancompletedaysbefore);
            }
            else if(this.form.cancompletedaysbefore == "")
            {
              this.form.cancompletedaysbefore == null;
            }
      
            this.recurringDaysIntervalNumber = Number(this.recurringDaysIntervalNumber);

              if(this.recurringDaysIntervalNumber <= this.form.cancompletedaysbefore){
                this.canCompleteError = true;
                return;
              }

              this.form.recurringdays.splice(0, 1, this.recurringDaysIntervalNumber);
      
             if(this.form.startdate != null && this.form.startdate < new Date().setHours(0,0,0,0))
              {
                this.startdateError = true;
                return;
              }

              var dateTimeInPropertyTimezone = this.getPropertyNowDate();

              var dateInProperty = new Date(dateTimeInPropertyTimezone);
            
              if(this.form.startdate != null && dateInProperty.setHours(0,0,0,0) > this.form.startdate.setHours(0,0,0,0)){
                this.propertyZoneError = true;
                return;
              }
              
              if(this.form.startdate != null)
              {
                  // this is very important, because this keeps the date according to the time zone of the users computer, and not the UTC time.
                  // if this is not done, the database can end up with a different date then the user entered, for example it's 11 at night fabruary
                  // 1 at the users location, but in utc it's already 2 AM from fabruary 2, then the system would post fabruary 2 (with UTC offset), and
                  // we in the back end take the date from the user straight and enter it in the database, since we want the date to be exactly as the 
                  // user had set it, then it would be inaccurate. As said this line will avoid it.
                  this.form.startdate = moment(this.form.startdate).format();
              }

              if(this.form.duedate != null)
              {
                  // this is doing the same as the earlier code block, for the due date instead of the start date. see comment above.
                  this.form.duedate = moment(this.form.duedate).format();
              }
         }

      this.loadingFormSubmit = true;

      EventService.updateIssue(this.issue.issueid, this.form).then( () => {
          let updateissuepackage = [this.issue, this.form];
          this.$emit("update-issue-locally", updateissuepackage);
          this.dialogClose();
      })
       .catch(error => {
          console.log(error);
          this.dialogClose();
      });


    },
     dialogClose() {
      this.$emit("close-edit-issue-form");
    }
  }
};
</script>

<style scoped>
.error{
    color: red;
    font-size: 12px;
    margin: 0px 0px 0px 18px;
}

.tst {
  width: 100%;
}
.el-dialog {
  width: 100% !important;
}
</style>